export var removeAllInjectedSagas = function (_a) {
    var store = _a.store, sagasNotToReplace = _a.sagasNotToReplace;
    // get injected sagas
    var injectedSagas = store.asyncSagas;
    // delete sagas from injected sagas registry and stop them
    Object.keys(injectedSagas).forEach(function (sagaName) {
        var isSagaStable = Boolean(sagasNotToReplace.find(function (notReplacedSagaName) { return notReplacedSagaName === sagaName; }));
        if (!isSagaStable) {
            injectedSagas[sagaName].cancel();
            delete injectedSagas[sagaName];
        }
    });
};
